import cc from 'classcat';

import {
  selectContentType,
  selectFields,
} from '#src/lib/contentful/selectors.mjs';

import { ContentRow } from '../ContentRow.js';

import { getRowStyles } from './helpers/get-ornamentation-row-styles.js';
import styles from './Ornamentation.scss';

export function Ornamentation({ ornamentation, leftFirst }) {
  return (
    ornamentation?.length > 0 && (
      <ul
        className={cc([
          styles.ornamentations,
          {
            [styles.leftFirst]: leftFirst,
            [styles.rightFirst]: !leftFirst,
          },
        ])}
      >
        {ornamentation.map((row, i) => (
          <li key={i}>
            <ContentRow
              className={styles[selectContentType(row)]}
              classNames={getRowStyles(row)}
              contentTypeId={selectContentType(row)}
              {...selectFields(row)}
            />
          </li>
        ))}
      </ul>
    )
  );
}
